import { ui, dia } from '@joint/plus';
import { NavigatorElementView } from '../components/NavigatorElementView.js';
import { DEFAULTS } from './config.js';

export function initNavigator(scroller) {
  const backgroundImage = require('../../../assets/CDG_withBoxes_Full_12kpx_G4.png');

  const navigator = new ui.Navigator({
    paperScroller: scroller,
    width: DEFAULTS.minimap.width,
    height: DEFAULTS.minimap.height,
    padding: DEFAULTS.minimap.padding,
    useContentBBox: false,
    paperOptions: {
      async: true,
      sorting: dia.Paper.sorting.APPROX,
      elementView: NavigatorElementView,
      cellViewNamespace: {},
      viewport: {
        stroke: 'var(--jj-accent-primary)',
        strokeWidth: 1,
        strokeOpacity: 0.8,
        fill: 'transparent',
        dasharray: '5,5',
      },
      background: {
        color: 'var(--jj-bg-paper)',
        image: backgroundImage,
        repeat: 'no-repeat',
        position: { x: 0, y: 0 },
        opacity: 1,
      },
    },
  });

  navigator.el.addEventListener('transitionend', () => navigator.updateCurrentView());
  return navigator;
}
